<template>
  <div class="input-ele-div posRelative clearFloat">
    <!-- 通用的表单 input元素 -->
    <label v-if="eleData.labelName" class="popup-label">{{
      eleData.labelName
    }}</label>
    <div class="float-right">
      <input
        v-if="eleData.inputType == 'text'"
        v-model.number="eleData.value"
        type="text"
        :class="eleData.isDisabled ? 'disabled' : ''"
        :placeholder="
          eleData.placeholder ||
            (eleData.key == 'baoe'
              ? '请输入保额'
              : eleData.key == 'baof'
                ? '请输入保费'
                : '请输入值')
        "
        :maxlength="eleData.maxlength || 9"
        :readonly="eleData.isDisabled ? true : null"
        @focus="
          showUnitValue = true
          getUnitValue()
        "
        @blur="showUnitValue = false"
        @input="getUnitValue()"
        @change="onchange"
      >
      <input
        v-else
        v-model.number="eleData.value"
        type="tel"
        :class="eleData.isDisabled ? 'disabled' : ''"
        :placeholder="
          eleData.placeholder ||
            (eleData.key == 'baoe'
              ? '请输入保额'
              : eleData.key == 'baof'
                ? '请输入保费'
                : '请输入值')
        "
        :maxlength="eleData.maxlength || 9"
        :readonly="eleData.isDisabled ? true : null"
        @focus="
          showUnitValue = true
          getUnitValue()
        "
        @blur="showUnitValue = false"
        @input="getUnitValue()"
        @change="onchange"
      >

      <div v-if="unitValue && showUnitValue" class="unit-tips">
        <span class="unit-tips-tx">{{ unitValue }}</span>
        <em />
      </div>
      <cm-icon-clear
        v-if="eleData.value && !eleData.isDisabled"
        @clearData="clearInputData"
      />
    </div>
  </div>
</template>

<script>
import cmIconClear from './commonIconClear'

export default {
  name: 'CmCommonInput',
  components: {
    cmIconClear
  },
  props: {
    eleData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      unitValue: '',
      showUnitValue: false
    }
  },
  computed: {
    value() {
      return this.eleData.value
    }
  },
  methods: {
    onchange() {
      this.$emit('changeEleData', this)
    },
    onFocus() {
      this.$el.getElementsByTagName('input')[0].scrollIntoView()
    },
    clearInputData() {
      this.eleData.value = ''
      this.onchange()
    },
    getUnitValue() {
      let digits = isNaN(this.eleData.value * 1)
        ? 0
        : Math.floor(Math.log10(this.eleData.value) + 1)
      switch (digits) {
        case 5:
          this.unitValue = '万'
          break
        case 6:
          this.unitValue = '十万'
          break
        case 7:
          this.unitValue = '百万'
          break
        case 8:
          this.unitValue = '千万'
          break
        case 9:
          this.unitValue = '亿'
          break
        default:
          this.unitValue = ''
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
input {
  font-size: 0.28rem;
  color: #333;
  border: none;
  vertical-align: middle;
  background: transparent;
  appearance: none;
  &::-webkit-input-placeholder {
    color: #ccc;
  }
}
input[type='tel'],
input[type='text'] {
  width: 2.56rem;
  height: 0.54rem;
  padding: 0.1rem 0.12rem 0.06rem;
  border: 1px solid #e5e5e5;
  border-radius: 0.04rem;
}
.input-ele-div {
  position: relative;
  width: 100%;
  .popup-label {
    width: 2.56rem;
    margin-right: 0.24rem;
    line-height: 0.96rem;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    vertical-align: middle;
  }
  .float-right {
    position: relative;
    float: right;
    font-size: 0;
    line-height: 0.92rem;
  }
  .unit-tips {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 0.16rem;
    margin-top: 0.22rem;
    line-height: normal;
    .unit-tips-tx {
      position: relative;
      display: inline-block;
      padding: 0.2rem 0.24rem;
      line-height: normal;
      background: #666;
      color: #fff;
      font-size: 0.24rem;
      border-radius: 0.08rem;
      z-index: 2;
    }
    em {
      display: inline-block;
      position: absolute;
      top: -0.05rem;
      left: 50%;
      width: 0.1rem;
      height: 0.1rem;
      background: #666;
      transform: translateX(-50%) rotate(45deg);
      content: '';
      z-index: 1;
    }
  }
}
</style>
